module.exports = __webpack_public_path__ + "img/service_3.38c5078e.png";